import $ from "jquery";

export default class MyAccountRegister {
    constructor() {
        this.registerForm = document.querySelector(".jsMyAccountRegisterForm");

        if (this.registerForm) {
            this.selectFields = Array.from(
                this.registerForm.querySelectorAll(".jsRegisterFormSelect")
            );

            if (this.selectFields.length) {
                this.events();
            }
        }
    }

    events() {
        this.selectFields.forEach((select) =>
            this.initializeSelectField(select)
        );
    }

    initializeSelectField(select) {
        const selectField = select;

        $(selectField).select2({
            minimumResultsForSearch: -1,
            dropdownCssClass: "dropdown-simple",
        });
    }
}
